
<div class="max-h-[24px]">
  <button v-if="favoritedSitter" :aria-label="favoritedLabel" @click="unfavoriteSitter">
    <heart-icon color="#4B4C52" class="mt-auto mb-auto" />
  </button>
  <button v-else @click="favoriteSitter">
    <heart-outline-icon color="#4B4C52" class="mt-auto mb-auto" />
  </button>
</div>
